const rolloTenantId = import.meta.env.VITE_ROLLO_TENANT_ID;
if (!rolloTenantId) {
  throw new Error("VITE_ROLLO_TENANT_ID is not set");
}

const cotenAuthEnvironment = import.meta.env.VITE_COTEN_AUTH_ENVIRONMENT;
if (cotenAuthEnvironment !== "local" && cotenAuthEnvironment !== "dev" && cotenAuthEnvironment !== "prd") {
  throw new Error("VITE_COTEN_AUTH_ENVIRONMENT must be local, dev, or prd");
}

const cotenAuthClientId = import.meta.env.VITE_COTEN_AUTH_CLIENT_ID;
if (!cotenAuthClientId) {
  throw new Error("VITE_COTEN_AUTH_CLIENT_ID is not set");
}
const cotenAuthApiOrigin = import.meta.env.VITE_COTEN_AUTH_API_ORIGIN || undefined;
if (cotenAuthEnvironment === "prd" && cotenAuthApiOrigin !== "https://auth-api.coten.app") {
  throw new Error("VITE_COTEN_AUTH_API_ORIGIN must be https://auth-api.coten.app in prd");
}

export const config = {
  environment: import.meta.env.VITE_ENVIRONMENT,
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,
  faroCollectorUrl: import.meta.env.VITE_FARO_COLLECTOR_URL,
  graphqlEndpoint: import.meta.env.VITE_HASURA_URL,
  cnutGraphqlEndpoint: import.meta.env.VITE_CNUT_URL,
  cotenAccountOrigin:
    import.meta.env.VITE_COTEN_ACCOUNT_ORIGIN ||
    (cotenAuthEnvironment === "local"
      ? "https://lo.coten.dev:3090"
      : cotenAuthEnvironment === "prd"
        ? "https://id.coten.app"
        : "https://id.coten.dev"),
  cotenAuth: {
    environment: cotenAuthEnvironment,
    clientId: cotenAuthClientId,
    authenticationApiOrigin: cotenAuthApiOrigin,
    authenticationEmulatorClientId: import.meta.env.VITE_COTEN_AUTH_EMULATOR_CLIENT_ID || undefined,
    cotenIdApiOrigin: import.meta.env.VITE_COTEN_ID_API_ORIGIN || undefined,
  },
  firebase: {
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  },
  appsync: {
    graphqlEndpoint: import.meta.env.VITE_JOBLOG_APPSYNC_URL,
    apiKey: import.meta.env.VITE_JOBLOG_APPSYNC_API_KEY,
  },
  compoundRecordComposerFileUpload: {
    maxRows: Number.parseInt(import.meta.env.VITE_COMPOUND_RECORD_COMPOSER_CSV_MAX_ROWS ?? "1000", 10),
    maxFileSizeBytes: 10_000_000,
  },
  eventNormalizationImport: {
    maxFileSizeBytes: 10_000_000,
  },
  rolloTenantId,
};
